import { createBreadcrumbGroupLoader } from "@amzn/awsui-app-layout-loader";
import { createWidgetizedBreadcrumbGroup, BreadcrumbGroupImplementation } from "./implementation";

export const InternalBreadcrumbGroup = createWidgetizedBreadcrumbGroup(
  createBreadcrumbGroupLoader({ Fallback: BreadcrumbGroupImplementation }),
);
